import { HelpCircle, PlayCircle } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { JurBadge } from "@/components/copiloto/EstadoBadge";

const fecha = (iso) => (iso ? new Date(iso).toLocaleDateString("es-MX", { dateStyle: "medium" }) : null);
const TAB = "text-sm text-slate-700 leading-relaxed whitespace-pre-line max-h-[260px] overflow-y-auto pr-1";

export const WhyCard = ({ why, name, isOwner }) => {
  const placeholder = why.id?.startsWith("placeholder.");
  return (
    <div>
      <div className="flex items-start gap-2 mb-2">
        <div className="w-8 h-8 rounded-full bg-[#EDF5F3] flex items-center justify-center shrink-0">
          <HelpCircle className="w-4 h-4 text-[#2A5C55]" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <div className="text-[10px] font-bold text-[#2A5C55] uppercase tracking-widest">Copiloto</div>
            {!placeholder && <JurBadge jur={why.jurisdiccion} referencia={why.referencia_cdmx} testid={`why-jurisdiccion-${name}`} />}
          </div>
          <h4 className="font-heading font-extrabold text-slate-900 text-base leading-tight mt-0.5">{why.title}</h4>
        </div>
      </div>
      {placeholder ? (
        <div className="text-sm text-slate-500">Contenido en preparación por el equipo de revisión jurídica.</div>
      ) : (
        <Tabs defaultValue="como">
          <TabsList className="w-full grid grid-cols-3 h-8">
            <TabsTrigger value="como" className="text-xs" data-testid={`why-tab-como-${name}`}>Cómo sí</TabsTrigger>
            <TabsTrigger value="dudas" className="text-xs" data-testid={`why-tab-dudas-${name}`}>Dudas reales</TabsTrigger>
            <TabsTrigger value="fundamento" className="text-xs" data-testid={`why-tab-fundamento-${name}`}>Fundamento legal</TabsTrigger>
          </TabsList>
          <TabsContent value="como" className={TAB}>{why.body}</TabsContent>
          <TabsContent value="dudas" className={TAB}>{why.dudas || "Aún no hay dudas registradas."}</TabsContent>
          <TabsContent value="fundamento" className="text-sm text-slate-700" data-testid={`why-source-${name}`}>
            {why.source || "Sin fuente registrada."}
            {why.referencia_cdmx && <p className="mt-2 text-xs text-[#92400E]">Aún no hay versión para tu estado; se muestra la de CDMX como referencia.</p>}
            {fecha(why.fecha_revision) && <p className="mt-2 text-xs text-slate-500">Revisado: {fecha(why.fecha_revision)}</p>}
          </TabsContent>
        </Tabs>
      )}
      {!placeholder && why.url_contenido && (
        <a href={why.url_contenido} target="_blank" rel="noopener noreferrer" data-testid={`why-video-${name}`}
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1E3A5F] hover:underline">
          <PlayCircle className="w-4 h-4" /> Ver video
        </a>
      )}
      {isOwner && <div className="mt-3 pt-2 border-t border-dashed border-[#E2DCD2] text-[10px] text-slate-500 font-mono truncate" data-testid={`why-admin-${name}`}>{why.id}</div>}
    </div>
  );
};
